/* Path: frontend/src/components/nav/Navigation.js */
import React, { useState, useRef, useEffect } from "react";
import "./Navigation.css"; // Import the CSS file (assuming co-location now)

// Navigation component now accepts loggedInUser and onLogout as props
const Navigation = ({ onNavigate, loggedInUser, onLogout }) => {
  console.log("Navigation.js: loggedInUser prop received:", loggedInUser); // ADD THIS
  // Ensure loggedInUser has a 'username' property if it's an object
  if (loggedInUser && !loggedInUser.username) {
    console.warn(
      "Navigation.js: loggedInUser object exists, but has no 'username' property:",
      loggedInUser
    ); // ADD THIS
  }

  const [showDropdown, setShowDropdown] = useState(false); // State to control dropdown visibility
  const dropdownRef = useRef(null); // Ref for detecting clicks outside the dropdown

  // Effect to handle clicks outside the dropdown to close it
  useEffect(() => {
    const handleClickOutside = (event) => {
      // If the dropdown ref exists and the click is outside the dropdown's current element, close it.
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    // Add event listener when dropdown is open
    if (showDropdown) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      // Clean up the event listener when dropdown is closed
      document.removeEventListener("mousedown", handleClickOutside);
    }

    // Cleanup function to remove event listener on component unmount
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showDropdown]); // Re-run effect when showDropdown changes

  // Function to toggle dropdown visibility
  const toggleDropdown = () => {
    setShowDropdown((prev) => !prev);
  };

  // Handle logout action
  const handleLogoutClick = () => {
    onLogout(); // Call the onLogout function passed from App.js
    setShowDropdown(false); // Close the dropdown after logout
  };

  return (
    <nav className="navigation-container">
      <div
        className="image-container"
        onClick={() => onNavigate("home")}
        style={{ cursor: "pointer" }}
        title="Go to Home"
      >
        {/* You can add an <img src="logo.png" alt="Logo" /> here if needed */}
      </div>

      {/* Your banner/logo container */}
      <ul className="navigation-list">
        <li>
          <button onClick={() => onNavigate("transactions")}>
            Transactions
          </button>
        </li>
        <li>
          <button onClick={() => onNavigate("inventory")}>Inventory</button>
        </li>

        <li>
          <button onClick={() => onNavigate("reports")}>Reports</button>
        </li>
        <li>
          <button onClick={() => onNavigate("settings")}>Settings</button>
        </li>
      </ul>
      {/* User section with dropdown, displayed only if a user is logged in */}
      {loggedInUser && (
        <div className="user-section" ref={dropdownRef}>
          <button className="user-display-button" onClick={toggleDropdown}>
            Welcome, {loggedInUser.username}!
            <span className="dropdown-arrow">{showDropdown ? "▲" : "▼"}</span>{" "}
            {/* Dropdown arrow icon */}
          </button>
          {showDropdown && (
            <div className="user-dropdown">
              <button
                className="dropdown-item"
                onClick={() => {
                  onNavigate("my-account"); // Navigate to 'my-account' page
                  setShowDropdown(false); // Close dropdown
                }}
              >
                My Account
              </button>
              <button
                className="dropdown-item"
                onClick={handleLogoutClick} // Call the specific logout handler
              >
                Logout
              </button>
              {/* Add more options here if needed */}
            </div>
          )}
        </div>
      )}
    </nav>
  );
};

export default Navigation;
